// standar react component 
import {Link, useParams, useLocation} from 'react-router-dom';
import {useEffect, useState} from 'react';

import './App.css';
import './index.css';
import CustomerComboBox from './CustomerComboBox';
import MediaTypeDropdown from './MediaTypeDropdown';
import Titlebar from './Titlebar';
import { TrashIcon } from '@heroicons/react/24/outline';
import SpotComboBox from './SpotComboBox';
import { apiUrl } from './config';
import useUserStore from './UserStore';

// declare order component
function OrderEntryForm({ readOnly = false }) {

  // pull from path parameter
  const { packageId, orderId } = useParams(); // Extract both packageId and orderId from URL
  const location = useLocation();
  const isCloneMode = location.pathname === '/orderentry/clone';

  // State management
  const [ currentOrderId, setCurrentOrderId ] = useState(orderId || null);
  const [ isEditMode, setIsEditMode ] = useState(!!orderId); // true if orderId exists
  const [ orderTemplate, setOrderTemplate ] = useState(null);
  const [ customers, setCustomers ] = useState(null);
  const [ selectedCustomer, setSelectedCustomer ] = useState(null);
  const [ orderCustomerId, setOrderCustomerId] = useState(null);
  const [ checkedItems, setCheckedItems ] = useState([]);
  const [ customPrice, setCustomPrice ] = useState(0);
  const [ agencyCommission, setAgencyCommission ] = useState(0);
  const [ customerComboBoxKey, setCustomerComboBoxKey] = useState(0);
  const [salesRepEmail, setSalesRepEmail] = useState('');
  const [salesRepOptions, setSalesRepOptions] = useState([]);
  const [linkedInvoiceId, setLinkedInvoiceId] = useState('');
  const [isInvoiceLookupLoading, setIsInvoiceLookupLoading] = useState(false);
  const [isConfirmationDownloading, setIsConfirmationDownloading] = useState(false);

  const [spots, setSpots] = useState([]);
  const [spotsLoading, setSpotsLoading] = useState(true);
  const [spotsError, setSpotsError] = useState(null);
  const user = useUserStore((state) => state.user);

  const userEmail = user?.email
    || user?.user?.email
    || user?.authResponse?.profile?.email
    || '';

  const rawUserRoles = [
    ...(Array.isArray(user?.roles) ? user.roles : []),
    ...(Array.isArray(user?.user?.roles) ? user.user.roles : []),
    ...(Array.isArray(user?.profile?.roles) ? user.profile.roles : []),
    ...(Array.isArray(user?.profileinfo?.roles) ? user.profileinfo.roles : []),
    ...(Array.isArray(user?.authResponse?.profile?.roles) ? user.authResponse.profile.roles : []),
  ];

  const userRoles = rawUserRoles
    .map((role) => {
      if (typeof role === 'string') {
        return role;
      }
      if (role && typeof role === 'object') {
        return role.name || role.role || role.value || '';
      }
      return '';
    })
    .filter(Boolean);

  const isAdmin = userRoles.some((role) => String(role || '').trim().toLowerCase() === 'admin');

  const currencyFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

  const normalizeEmail = (value) => (value || '').toString().trim().toLowerCase();

  const getOrderSalesRepEmail = () => {
    return orderTemplate?.sales_rep_email
      || orderTemplate?.sales_rep
      || orderTemplate?.salesRepEmail
      || orderTemplate?.account_rep
      || salesRepEmail
      || '';
  };

  const canManageInvoice = readOnly && (
    isAdmin || normalizeEmail(getOrderSalesRepEmail()) === normalizeEmail(userEmail)
  );

  const toLocalDateString = (date) => {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const normalizeDateValue = (value) => {
    if (!value) return '';
    if (value instanceof Date) return toLocalDateString(value);
    if (typeof value === 'string') {
      if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
      if (value.includes('T')) return value.split('T')[0];
    }
    const parsed = new Date(value);
    if (!Number.isNaN(parsed.getTime())) return toLocalDateString(parsed);
    return '';
  };

  const parseLocalDate = (value) => {
    const normalized = normalizeDateValue(value);
    if (!normalized) return null;
    const [year, month, day] = normalized.split('-').map(Number);
    return new Date(year, month - 1, day, 12, 0, 0, 0);
  };

  const normalizeMediaType = (value) => {
    const normalized = (value || '').toString().trim().toLowerCase();
    if (!normalized) return '';
    if (normalized === 'spot') return 'Spot';
    if (normalized === 'trade') return 'Trade';
    if (normalized === 'package') return 'Package';
    if (normalized === 'bonus') return 'Bonus';
    if (normalized === 'custom') return 'Custom';
    if (normalized === 'make good' || normalized === 'make_good' || normalized === 'makegood') return 'Make Good';
    return value;
  };

  const buildCartNumberFromSpot = (spot) => {
    if (!spot || typeof spot !== 'object') return '';
    const cart = spot.cart ?? '';
    const cut = spot.cut ?? '';
    if (!cart) return '';
    return cut !== '' ? `${cart}-${cut}` : `${cart}`;
  };

  const findSpotByCartNumber = async (cartNumber) => {
    if (!cartNumber) return null;
    
    try {
      const response = await fetch(apiUrl(`/media/cart?cart=${cartNumber}`), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
      });

      if (!response.ok) {
        console.error(`Failed to fetch spot for cart ${cartNumber}: ${response.status}`);
        return null;
      }

      const spot = await response.json();
      console.log(`Found spot for cart ${cartNumber}:`, spot);
      return spot;
    } catch (error) {
      console.error(`Error fetching spot for cart ${cartNumber}:`, error);
      return null;
    }
  };



  console.log(packageId)
  
  const addOrderLine = (event) => {
        console.log('addOrderLine');

        const today = new Date();
        const nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1);
      const startDate = toLocalDateString(nextMonth); // First day of next month
        
        // Last day of next month
        const lastDay = new Date(nextMonth.getFullYear(), nextMonth.getMonth() + 1, 0);
        const endDate = toLocalDateString(lastDay);

        const newLine = {
            id: '0',
            start_date: startDate,
            end_date: endDate,
            media_type: 'Spot',
            start_time: '00:00',
            end_time: '23:59',
            cart_number: '1',
            customer_name: '',
            checked: false,
            mon: 0,
            tues: 0,
            wed: 0,
            thur: 0,
            fri: 0,
            sat: 0,
            sun: 0,
          unit_cost: 15.00,
          unit_cost_overridden: false,
          total_cost: 0,
            create_date: new Date(),
            modified_date: new Date(),
            term_date: null,
        };

        let clonedOrderTemplate = {...orderTemplate};
        clonedOrderTemplate.items.push(newLine);
        setOrderTemplate(clonedOrderTemplate);

        // loop through items to calculate total cost
        for (let i = 0; i < clonedOrderTemplate.items.length; i++) {
            clonedOrderTemplate.items[i].total_cost = calculateTotalCost(clonedOrderTemplate.items[i]);
        }

        // Recalculate totals after adding a new line
        totals();
  }

    const totals = (templateData = orderTemplate) => {
      if (!templateData || !templateData.items) return;
        
      let clonedOrderTemplate = {...templateData};
      clonedOrderTemplate.items = [...templateData.items]; // Deep clone the items array
        
        let total_cash = 0;
      let total_custom = 0;
        let total_trade = 0;
        let total_package = 0;
        let total_quantity = 0;
        let minStartDate = null;
        let maxEndDate = null;      

        // First, recalculate each item's cost
        for (let i = 0; i < clonedOrderTemplate.items.length; i++) {
            const item = {...clonedOrderTemplate.items[i]}; // Clone each item
            
            // Set unit cost based on media type
            // Only set unit_cost from media_type defaults if the user hasn't overridden it
            if (!item.unit_cost_overridden) {
              if (item.media_type === 'Spot') {
                item.unit_cost = 15.00;
              } else if (item.media_type === 'Trade') {
                item.unit_cost = 20.00;
              } else if (item.media_type === 'Package') {
                item.unit_cost = 25.00;
              } else if (item.media_type === 'Bonus' || item.media_type === 'Make Good') {
                item.unit_cost = 0.00;
              } else if (item.media_type === 'Custom') {
                // Prefer a per-item unit_cost if already provided, otherwise fall back to the global customPrice
                item.unit_cost = parseFloat(item.unit_cost || customPrice) || 0;
              }
            }
            
            // Recalculate total cost for this item
            item.total_cost = calculateTotalCost(item);
            
            // Update the cloned item in the array
            clonedOrderTemplate.items[i] = item;
            
            // Add to category totals
            if (item.media_type === 'Spot') {
                total_cash += parseFloat(item.total_cost || 0);
            } else if (item.media_type === 'Trade') {
                total_trade += parseFloat(item.total_cost || 0);
            } else if (item.media_type === 'Package') {
                total_package += parseFloat(item.total_cost || 0);
            } else if (item.media_type === 'Custom') {
              total_custom += parseFloat(item.total_cost || 0);
            }

            total_quantity += parseInt(item.quantity || 0);

            // Track min start_date and max end_date
            if (item.start_date) {
              const normalizedStartDate = normalizeDateValue(item.start_date);
              if (normalizedStartDate && (!minStartDate || normalizedStartDate < minStartDate)) {
                minStartDate = normalizedStartDate;
                }
            }

            if (item.end_date) {
              const normalizedEndDate = normalizeDateValue(item.end_date);
              if (normalizedEndDate && (!maxEndDate || normalizedEndDate > maxEndDate)) {
                maxEndDate = normalizedEndDate;
                }
            }        
        }
        
        const normalizedOrderType = (clonedOrderTemplate.order_type || '').toString().trim().toLowerCase();
        const customToTrade = normalizedOrderType === 'trade' || normalizedOrderType === 'trede';

        // cash_total refers only to true cash line totals (do not include custom/trade/package)
        const cash_total = total_cash;

        // Agency commission discounts the cash total only and should NOT change total_value
        const commissionPercent = Number(clonedOrderTemplate.agency_commission ?? agencyCommission) || 0;
        const discounted_cash_total = (normalizedOrderType === 'agency' && commissionPercent > 0)
          ? (cash_total - (cash_total * (commissionPercent / 100)))
          : cash_total;

        // Set the calculated totals
        clonedOrderTemplate.total_cost = discounted_cash_total; // discounted cash total when agency
        clonedOrderTemplate.total_trade = customToTrade ? (total_trade + total_custom) : total_trade;
        clonedOrderTemplate.total_package = total_package;
        // total_value should be the sum of all line items without agency discount
        clonedOrderTemplate.total_value = (total_cash + total_trade + total_package + total_custom);
        clonedOrderTemplate.total_quantity = total_quantity;

        // Set the order's start_date and end_date based on items
        if (minStartDate) {
          clonedOrderTemplate.start_date = minStartDate;
        }
        
        if (maxEndDate) {
          clonedOrderTemplate.end_date = maxEndDate;
        }
        
        console.log(`Order date range: ${clonedOrderTemplate.start_date} to ${clonedOrderTemplate.end_date}`);      
        console.log('Campaign preserved:', clonedOrderTemplate.campaign); // Add this to verify
        
        setOrderTemplate(clonedOrderTemplate);
    };

    const deleteOrderLines = () => {
        let clonedOrderTemplate = {...orderTemplate};
        clonedOrderTemplate.items = clonedOrderTemplate.items.filter((item, index) => !checkedItems.includes(index));
        setOrderTemplate(clonedOrderTemplate);

        setCheckedItems([]);
    };

    const setCheckedItem = (index) => (event) => {
        let clonedOrderTemplate = {...orderTemplate};
        if (event.target.checked) {
            console.log('adding checked index:' + index);
            checkedItems.push(index);
            clonedOrderTemplate.items[index].checked = event.target.checked;
            setOrderTemplate(clonedOrderTemplate);
        } else {
            console.log('removing checked index:' + index);
            const itemIndex = checkedItems.indexOf(index);
            if (itemIndex > -1) {
                checkedItems.splice(itemIndex, 1);
            }
            clonedOrderTemplate.items[index].checked = event.target.checked;
            setOrderTemplate(clonedOrderTemplate);
        }
    }; 

    // Add a function to calculate total spots by iterating through date range
    const calculateTotalSpotsByDateRange = (startDate, endDate, daySpots) => {
        if (!startDate || !endDate) return 0;
        
      const start = parseLocalDate(startDate);
      const end = parseLocalDate(endDate);
      if (!start || !end) return 0;
        let totalSpots = 0;
        
        // Iterate through each day from start to end
        for (let currentDate = new Date(start); currentDate <= end; currentDate.setDate(currentDate.getDate() + 1)) {
            const dayOfWeek = currentDate.getDay(); // 0 = Sunday, 1 = Monday, etc.
            
            // Map JavaScript day numbers to our day properties
            let spotsForThisDay = 0;
            switch (dayOfWeek) {
            case 0: // Sunday
                spotsForThisDay = parseInt(daySpots.sun || 0);
                break;
            case 1: // Monday
                spotsForThisDay = parseInt(daySpots.mon || 0);
                break;
            case 2: // Tuesday
                spotsForThisDay = parseInt(daySpots.tues || 0);
                break;
            case 3: // Wednesday
                spotsForThisDay = parseInt(daySpots.wed || 0);
                break;
            case 4: // Thursday
                spotsForThisDay = parseInt(daySpots.thur || 0);
                break;
            case 5: // Friday
                spotsForThisDay = parseInt(daySpots.fri || 0);
                break;
            case 6: // Saturday
                spotsForThisDay = parseInt(daySpots.sat || 0);
                break;
            default:
                spotsForThisDay = 0;
                break;
            }
            
            totalSpots += spotsForThisDay;
        }
        
        return totalSpots;
    };

  // Add this useEffect to handle customer selection updates
  useEffect(() => {
    console.log('Selected customer changed:', selectedCustomer);
    // Force CustomerComboBox to update by triggering a re-render
    if (selectedCustomer) {
      console.log('Customer is now selected:', selectedCustomer.name);
    }
  }, [selectedCustomer]);

  useEffect(() => {
    if (orderId && isEditMode) {
      const loadExistingOrder = async () => {
        try {
          console.log('Loading existing order:', orderId);
          
          const response = await fetch(apiUrl(`/order/byid/${orderId}`), {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
            mode: 'cors',
          });

          if (!response.ok) {
            throw new Error(`Failed to load order: ${response.status}`);
          }

          let existingOrder = await response.json();
          console.log('Loaded existing order (raw):', existingOrder);

          // Handle response envelope - check if response is wrapped
          if (existingOrder && typeof existingOrder === 'object' && existingOrder.data) {
            existingOrder = existingOrder.data;
          }
          
          console.log('Loaded existing order (unwrapped):', existingOrder);
          console.log('order_type from API:', existingOrder.order_type, 'orderType:', existingOrder.orderType);

          // Transform the existing order data to match the orderTemplate structure
          const transformedOrder = {
            id: existingOrder._id || existingOrder.id || '0',
            name: existingOrder.package_name || '',
            package_id: existingOrder.package_id || '',
            customer_id: existingOrder.customer_id || '',
            customer_account: existingOrder.customer_account || '',
            customer_name: existingOrder.customer_name || '',
            customer_address: existingOrder.customer_address || '',
            customer_email: existingOrder.customer_email || '',
            customer_phone: existingOrder.customer_phone || '',
            salesRepEmail: existingOrder.salesRepEmail || existingOrder.sales_rep_email || existingOrder.sales_rep || existingOrder.account_rep || '',
            sales_rep_email: existingOrder.sales_rep_email || existingOrder.sales_rep || existingOrder.account_rep || '',
            order_type: (() => {
              const val = (existingOrder.order_type || existingOrder.orderType || '').toString().trim();
              return val ? val.charAt(0).toUpperCase() + val.slice(1).toLowerCase() : '';
            })(),

            campaign: existingOrder.campaign || '',
            total_cost: existingOrder.total_cost || 0,
            total_trade: existingOrder.total_trade || 0,
            total_package: existingOrder.total_package || 0,
            total_value: existingOrder.total_value || 0,
            total_quantity: existingOrder.total_quantity || 0,
            start_date: normalizeDateValue(existingOrder.start_date),
            end_date: normalizeDateValue(existingOrder.end_date),
            order_date: normalizeDateValue(existingOrder.order_date) || toLocalDateString(new Date()),
            items: (existingOrder.orderlines || []).map((item) => ({
              ...item,
              media_type: normalizeMediaType(item.media_type),
              unit_cost_overridden: true,
              start_date: normalizeDateValue(item.start_date),
              end_date: normalizeDateValue(item.end_date),
            }))
          };

        // Log the transformed order to verify order_type is set
        console.log('transformedOrder.order_type:', transformedOrder.order_type);
        
        // Set the order template with existing data
        // Pull agency commission from the payload if present
        transformedOrder.agency_commission = existingOrder.agency_commission || existingOrder.agencyCommission || 0;

        // If the payload includes an agency commission and order_type isn't explicitly set,
        // prefer Agency so the dropdown reflects the persisted commission state.
        if ((Number(transformedOrder.agency_commission) || 0) > 0) {
          const curType = (transformedOrder.order_type || '').toString().trim().toLowerCase();
          if (curType !== 'agency') {
            transformedOrder.order_type = 'Agency';
          }
        }

        setOrderTemplate(transformedOrder);

        // Set custom price if it exists
        if (existingOrder.custom_price) {
          setCustomPrice(existingOrder.custom_price);
        }

        // Set agency commission value
        if (transformedOrder.agency_commission) {
          setAgencyCommission(Number(transformedOrder.agency_commission) || 0);
        }

        // Store the customer ID for later use when customers are loaded
        if (existingOrder.customer_id) {
          setOrderCustomerId(existingOrder.customer_id);
        }

      } catch (error) {
        console.error('Error loading existing order:', error);
        alert(`Failed to load order: ${error.message}`);
        
        // Fallback to template loading if order loading fails
        setIsEditMode(false);
      }
    };

    loadExistingOrder();
  }
}, [orderId, isEditMode]); // Remove customers from dependencies

useEffect(() => {
  const fetchSalesRepProfiles = async () => {
    if (!isAdmin) {
      return;
    }

    const getEmailFromProfile = (profile) => {
      return profile?.email
        || profile?.profile_email
        || profile?.user?.email
        || profile?.authResponse?.profile?.email
        || '';
    };

    const listEndpoints = ['/profile/list', '/profile/all'];

    for (const endpoint of listEndpoints) {
      try {
        const response = await fetch(apiUrl(endpoint), {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          continue;
        }

        const data = await response.json();
        const profiles = Array.isArray(data) ? data : (Array.isArray(data?.data) ? data.data : []);
        const emails = [...new Set(profiles.map(getEmailFromProfile).filter(Boolean))];

        setSalesRepOptions(emails);
        return;
      } catch (error) {
        console.error(`Error loading sales reps from ${endpoint}:`, error);
      }
    }

    if (userEmail) {
      setSalesRepOptions([userEmail]);
    }
  };

  fetchSalesRepProfiles();
}, [isAdmin, userEmail]);

useEffect(() => {
  if (!orderTemplate) {
    return;
  }

  if (isAdmin) {
    const existingRep = orderTemplate.sales_rep_email || orderTemplate.sales_rep || orderTemplate.account_rep || '';
    if (existingRep) {
      setSalesRepEmail(existingRep);
      return;
    }
    if (salesRepEmail) {
      return;
    }
    if (userEmail) {
      setSalesRepEmail(userEmail);
    }
    return;
  }

  if (userEmail && salesRepEmail !== userEmail) {
    setSalesRepEmail(userEmail);
  }
}, [orderTemplate?.id, isAdmin, userEmail, salesRepEmail]);

useEffect(() => {
  const lookupInvoiceForOrder = async () => {
    if (!readOnly || !orderTemplate?.id || !canManageInvoice) {
      setLinkedInvoiceId('');
      return;
    }

    try {
      setIsInvoiceLookupLoading(true);
      const orderId = (orderTemplate.id || orderTemplate._id || '').toString();
      const response = await fetch(apiUrl(`/invoice/byorder/${orderId}`), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
      });

      if (!response.ok) {
        setLinkedInvoiceId('');
        return;
      }

      let invoiceData = await response.json();
      if (invoiceData && typeof invoiceData === 'object' && invoiceData.data) {
        invoiceData = invoiceData.data;
      }

      const invoice = Array.isArray(invoiceData) ? invoiceData[0] : invoiceData;
      setLinkedInvoiceId(invoice ? (invoice.id || invoice._id || '') : '');
    } catch (error) {
      console.error('Error looking up invoice for order:', error);
      setLinkedInvoiceId('');
    } finally {
      setIsInvoiceLookupLoading(false);
    }
  };

  lookupInvoiceForOrder();
}, [readOnly, orderTemplate?.id, orderTemplate?.customer_id, orderTemplate?.campaign, canManageInvoice]);

// Update the customer selection logic in the useEffect
useEffect(() => {
  if (customers && orderCustomerId && !selectedCustomer) {
    console.log('Looking for customer with ID:', orderCustomerId);
    console.log('Available customers:', customers);
    
    // Try to find customer by different possible ID fields
    let customer = customers.find(c => c._id === orderCustomerId) ||
                   customers.find(c => c.id === orderCustomerId) ||
                   customers.find(c => c.customer_id === orderCustomerId);
    
    if (customer) {
      console.log('Found and setting selected customer:', customer);
      
      // Set the customer with a small delay to ensure proper rendering
      setTimeout(() => {
        setSelectedCustomer(customer);
        setOrderCustomerId(null);
        
        // Force a re-render of CustomerComboBox by updating the key
        setCustomerComboBoxKey(Date.now());
      }, 100);
    } else {
      console.warn('Customer not found in customers array. Customer ID:', orderCustomerId);
      fetchSpecificCustomer(orderCustomerId);
    }
  }
}, [customers, orderCustomerId, selectedCustomer]);

// Helper function to fetch a specific customer if not in the main list
const fetchSpecificCustomer = async (customerId) => {
  try {
    console.log('Fetching specific customer:', customerId);
    const response = await fetch(apiUrl(`/customer/one?customerId=${customerId}`));
    
    if (response.ok) {
      const customerData = await response.json();
      console.log('Fetched specific customer:', customerData);
      
      // Add to customers array and set as selected
      setCustomers(prevCustomers => [...prevCustomers, customerData]);
      setSelectedCustomer(customerData);
      setOrderCustomerId(null);
    } else {
      console.error('Failed to fetch specific customer');
    }
  } catch (error) {
    console.error('Error fetching specific customer:', error);
  }
};

  // Add useEffect to fetch customers
  useEffect(() => {
    const fetchCustomers = async () => {
        const response = await fetch(apiUrl(`/customer/list`));
        const customers = await response.json();
        setCustomers(customers);
        console.log(customers);
    }

    fetchCustomers();
  }, []);

  // Add useEffect to fetch spots
  useEffect(() => {
    const fetchSpots = async () => {
      try {
        setSpotsLoading(true);
        setSpotsError(null);
        
        const response = await fetch(apiUrl('/media/all'), {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          mode: 'cors',
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch spots: ${response.status} ${response.statusText}`);
        }

        const spotsData = await response.json();
        console.log('Spots fetched successfully:', spotsData);
        
        // Handle both paginated and non-paginated responses
        const spots = spotsData.data || spotsData;
        
        // Ensure spots is an array
        if (Array.isArray(spots)) {
          setSpots(spots);
        } else {
          console.error('Expected spots data to be an array, received:', typeof spots);
          setSpots([]);
        }
        
      } catch (error) {
        console.error('Error fetching spots:', error);
        setSpotsError(error.message);
        setSpots([]); // Set empty array on error
      } finally {
        setSpotsLoading(false);
      }
    };

    fetchSpots();
  }, []); // Empty dependency array - runs once on component mount

  // Resolve cart_number to spot objects when loading existing order
  useEffect(() => {
    if (!spotsLoading && orderTemplate && orderTemplate.items && orderTemplate.items.length > 0 && isEditMode) {
      console.log('Resolving cart_numbers to spot objects');
      
      const resolveSpots = async () => {
        const updatedOrderTemplate = { ...orderTemplate };
        const resolvedItems = [];
        
        for (const item of orderTemplate.items) {
          // If cart_number exists but spot is not set, try to find the spot
          if (item.cart_number && !item.spot) {
            const foundSpot = await findSpotByCartNumber(item.cart_number);
            if (foundSpot) {
              console.log(`Found spot for cart_number ${item.cart_number}:`, foundSpot);
              resolvedItems.push({ ...item, spot: foundSpot });
            } else {
              resolvedItems.push(item);
            }
          } else {
            resolvedItems.push(item);
          }
        }
        
        if (resolvedItems.some((item, idx) => item.spot && !orderTemplate.items[idx].spot)) {
          console.log('Updating order template with resolved spots');
          updatedOrderTemplate.items = resolvedItems;
          setOrderTemplate(updatedOrderTemplate);
        }
      };
      
      resolveSpots();
    }
  }, [spotsLoading, isEditMode, orderTemplate?.id]);

  // Load template data for new orders
  useEffect(() => {
    let total_cash = 0;
    let total_custom = 0;
    let total_trade = 0;
    let total_package = 0;
    let total_quantity = 0;

    if (!isEditMode && isCloneMode) {
      const cloneData = sessionStorage.getItem('pendingCloneOrder');
      sessionStorage.removeItem('pendingCloneOrder');

      if (!cloneData) {
        console.error('No pending clone data found in sessionStorage');
        window.location.href = '/orders';
        return;
      }

      let cloneTemplate = JSON.parse(cloneData);

      // Strip the saved order ID so it saves as a new order
      delete cloneTemplate._id;
      delete cloneTemplate.id;

      // Normalize order_type to title case
      const cloneOrderTypeVal = (cloneTemplate.order_type || cloneTemplate.orderType || '').toString().trim();
      cloneTemplate.order_type = cloneOrderTypeVal
        ? cloneOrderTypeVal.charAt(0).toUpperCase() + cloneOrderTypeVal.slice(1).toLowerCase()
        : (isAdmin ? 'Cash' : '');

      // Normalize dates on items
      if (Array.isArray(cloneTemplate.orderlines)) {
        cloneTemplate.items = cloneTemplate.orderlines.map((item) => ({
          ...item,
          id: '0',
          media_type: normalizeMediaType(item.media_type),
          start_date: normalizeDateValue(item.start_date),
          end_date: normalizeDateValue(item.end_date),
        }));
        delete cloneTemplate.orderlines;
      } else {
        cloneTemplate.items = [];
      }

      // Normalize top-level order dates
      cloneTemplate.start_date = normalizeDateValue(cloneTemplate.start_date);
      cloneTemplate.end_date = normalizeDateValue(cloneTemplate.end_date);
      cloneTemplate.order_date = normalizeDateValue(cloneTemplate.order_date) || toLocalDateString(new Date());

      if (cloneTemplate.customer_id) {
        setOrderCustomerId(cloneTemplate.customer_id);
      }

      if (cloneTemplate.custom_price) {
        setCustomPrice(cloneTemplate.custom_price);
      }

      // Clone may include agency commission
      setAgencyCommission(cloneTemplate.agency_commission || cloneTemplate.agencyCommission || 0);

      setOrderTemplate(cloneTemplate);
      setTimeout(() => { totals(); }, 0);
      return;
    }

    if (!isEditMode && packageId) {
      const fetchTemplate = async () => {
        const response = await fetch(apiUrl(`/sales/ordertemplate?templateName=${packageId}`));
        let orderTemplate = await response.json();
        console.log('Template loaded:', orderTemplate);
        console.log('Template monthly price:', orderTemplate.monthly_price); // Add this to verify

        if (orderTemplate && orderTemplate.items) {
          // Ensure items is an array
          orderTemplate.items = Array.isArray(orderTemplate.items) ? orderTemplate.items : [];

          // Normalize order_type to title case (Cash, Trade, etc.)
          const orderTypeVal = (orderTemplate.order_type || orderTemplate.orderType || '').toString().trim();
          orderTemplate.order_type = orderTypeVal ? orderTypeVal.charAt(0).toUpperCase() + orderTypeVal.slice(1).toLowerCase() : (isAdmin ? 'Cash' : '');

          setCustomPrice(orderTemplate.custom_price || 0);

          // Calculate totals for each item and set unit costs
          for (let i = 0; i < orderTemplate.items.length; i++) {
            const item = orderTemplate.items[i];

            item.media_type = normalizeMediaType(item.media_type);

            console.log('Processing item (index: ', i, ', data: ', item, ')');

            // Calculate individual item total using the proper daySpots object
            const daySpots = {
              mon: item.mon || 0,
              tues: item.tues || 0,
              wed: item.wed || 0,
              thur: item.thur || 0,
              fri: item.fri || 0,
              sat: item.sat || 0,
              sun: item.sun || 0
            };
            
            const totalSpots = calculateTotalSpotsByDateRange(item.start_date, item.end_date, daySpots);
            
            // Only set unit_cost defaults if not overridden by the user
            if (!item.unit_cost_overridden) {
              if (item.media_type === 'Spot') {
                item.unit_cost = 15.00;
                item.total_cost = totalSpots * (item.unit_cost || 0);
              } else if (item.media_type === 'Trade') {
                item.unit_cost = 20.00;
                item.total_trade = totalSpots * (item.unit_cost || 0);
              } else if (item.media_type === 'Package') {
                item.unit_cost = 25.00;
                item.total_package = totalSpots * (item.unit_cost || 0);
              } else if (item.media_type === 'Bonus' || item.media_type === 'Make Good') {
                item.unit_cost = 0.00;
                item.total_bonus = totalSpots * (item.unit_cost || 0);
              } else if (item.media_type === 'Custom') {
                item.unit_cost = parseFloat(item.unit_cost || customPrice) || 0;
                item.total_cost = totalSpots * (item.unit_cost || 0);          
              }
            } else {
              // If overridden, still compute totals using the overridden unit_cost
              if (item.media_type === 'Trade') {
                item.total_trade = totalSpots * (item.unit_cost || 0);
              } else if (item.media_type === 'Package') {
                item.total_package = totalSpots * (item.unit_cost || 0);
              } else {
                item.total_cost = totalSpots * (item.unit_cost || 0);
              }
            }

            if (item.media_type === 'Spot') {
              total_cash += item.total_cost || 0;
            } else if (item.media_type === 'Trade') {
              total_trade += item.total_trade || 0;
            } else if (item.media_type === 'Package') {
              total_package += item.total_package || 0;
            } else if (item.media_type === 'Custom') {
              total_custom += item.total_cost || 0;
            }
            total_quantity += item.quantity || 0;

            orderTemplate.items[i] = item;
          }            
        } else {
          orderTemplate.items = [];
          orderTemplate.total_cash = 0;
          orderTemplate.total_trade = 0;
          orderTemplate.total_package = 0;
          orderTemplate.total_value = 0;
        }
        
        const normalizedOrderType = (orderTemplate.order_type || '').toString().trim().toLowerCase();
        const customToTrade = normalizedOrderType === 'trade' || normalizedOrderType === 'trede';

        // cash_total refers only to true cash line totals
        const cash_total = total_cash;
        const commissionPercent = Number(orderTemplate.agency_commission ?? agencyCommission) || 0;
        const discounted_cash_total = (normalizedOrderType === 'agency' && commissionPercent > 0)
          ? (cash_total - (cash_total * (commissionPercent / 100)))
          : cash_total;

        orderTemplate.total_cost = discounted_cash_total;
        orderTemplate.total_trade = customToTrade ? (total_trade + total_custom) : total_trade;
        orderTemplate.total_package = total_package;
        orderTemplate.total_value = (total_cash + total_trade + total_package + total_custom);

        setOrderTemplate(orderTemplate);
          // Set agency commission from template if present
          setAgencyCommission(orderTemplate.agency_commission || orderTemplate.agencyCommission || 0);

          // Then recalculate totals
          setTimeout(() => {
              totals();
          }, 0);
      };

      fetchTemplate();
    }
  }, [packageId, isEditMode, isAdmin, isCloneMode]); // Add dependency array with packageId and isEditMode


const calculateTotalCost = (item) => {
    const daySpots = {
        mon: item.mon || 0,
        tues: item.tues || 0,
        wed: item.wed || 0,
        thur: item.thur || 0,
        fri: item.fri || 0,
        sat: item.sat || 0,
        sun: item.sun || 0
    };

    const totalSpots = calculateTotalSpotsByDateRange(item.start_date, item.end_date, daySpots);
    let total_cost = totalSpots * (item.unit_cost || 0);
    console.log(`Calculated total cost for item: Start: ${item.start_date}, End: ${item.end_date}, Total spots: ${totalSpots}, Unit cost: $${item.unit_cost}, Total cost: $${total_cost}`);
    return total_cost;
};

  if (!customers) {
    return <div>Loading...</div>;
  }

  if (!orderTemplate) {
    return <div>Loading...</div>;
  }

  // Add a function to handle input changes
  const handleItemChange = (index, field) => (event) => {
      let clonedOrderTemplate = {...orderTemplate}; // This preserves campaign
      clonedOrderTemplate.items = [...orderTemplate.items]; // Clone the items array
      
      clonedOrderTemplate.items[index][field] = event.target.value;

      console.log(`Item ${index} changed field ${field} to ${event.target.value}`);

      // Calculate total_cost for this item if it's a day field, media_type, or date field
      if (['mon', 'tues', 'wed', 'thur', 'fri', 'sat', 'sun', 'media_type', 'spot','start_date', 'start_time', 'end_date', 'end_time'].includes(field)) {
          const item = clonedOrderTemplate.items[index];
          
          if (field === 'start_date' || field === 'end_date') {
              item[field] = normalizeDateValue(event.target.value);
          } 

          if (field === 'spot') {
              const selectedSpot = event.target.value;
              item.spot = selectedSpot;
              const cartNumber = buildCartNumberFromSpot(selectedSpot);
              if (cartNumber) {
                item.cart_number = cartNumber;
              }
          }

          if (field === 'start_time') {
              const timeString = event.target.value;
              item.start_time = timeString;
          }

          if (field === 'end_time') {
              const timeString = event.target.value;
              item.end_time = timeString;
          }

          // Set unit cost based on media type
            // Only set unit_cost defaults if the user hasn't overridden it
            if (!item.unit_cost_overridden) {
            if (item.media_type === 'Spot') {
              item.unit_cost = 15.00;
            } else if (item.media_type === 'Trade') {
              item.unit_cost = 20.00;
            } else if (item.media_type === 'Package') {
              item.unit_cost = 25.00;
            } else if (item.media_type === 'Bonus' || item.media_type === 'Make Good') {
              item.unit_cost = 0.00;
            } else if (item.media_type === 'Custom') {
              item.unit_cost = parseFloat(item.unit_cost || customPrice) || 0;
            }
            }

          // Calculate total by iterating through date range
          const daySpots = {
              mon: item.mon,
              tues: item.tues,
              wed: item.wed,
              thur: item.thur,
              fri: item.fri,
              sat: item.sat,
              sun: item.sun
          };

          const totalSpots = calculateTotalSpotsByDateRange(item.start_date, item.end_date, daySpots);
          item.total_cost = totalSpots * (item.unit_cost || 0);
          item.quantity = totalSpots;

          console.log(`Updated item ${index}: Start: ${item.start_date}, End: ${item.end_date}, Total spots: ${totalSpots}, Unit cost: $${item.unit_cost}, Total cost: $${item.total_cost}`);
      }
      
      // Set the state first to preserve campaign
      setOrderTemplate(clonedOrderTemplate);

      // Then recalculate totals
      setTimeout(() => {
          totals();
      }, 0);
  };

  // Handle direct edits to unit_cost per-line
  const handleUnitCostChange = (index) => (event) => {
    let clonedOrderTemplate = { ...orderTemplate };
    clonedOrderTemplate.items = [...orderTemplate.items];
    const item = clonedOrderTemplate.items[index];

    // Allow currency-formatted input like "$1,234.56" — strip non-numeric except dot and minus
    const raw = (event.target.value || '').toString().replace(/[^0-9.-]/g, '');
    const parsed = parseFloat(raw);
    item.unit_cost = Number.isNaN(parsed) ? 0 : parsed;
    item.unit_cost_overridden = true;

    // Recalculate totals for this item
    const daySpots = {
      mon: item.mon || 0,
      tues: item.tues || 0,
      wed: item.wed || 0,
      thur: item.thur || 0,
      fri: item.fri || 0,
      sat: item.sat || 0,
      sun: item.sun || 0
    };
    const totalSpots = calculateTotalSpotsByDateRange(item.start_date, item.end_date, daySpots);
    item.total_cost = totalSpots * (item.unit_cost || 0);
    item.quantity = totalSpots;

    setOrderTemplate(clonedOrderTemplate);
    setTimeout(() => { totals(); }, 0);
  };

  // Add the submitOrder function
  const submitOrder = async () => {
    try {
      // Validate required fields
      if (!selectedCustomer) {
        alert('Please select a customer before submitting the order.');
        return;
      }

      if (!orderTemplate.items || orderTemplate.items.length === 0) {
        alert('Please add at least one order line before submitting.');
        return;
      }

      // Prepare the order data
      const effectiveSalesRepEmail = salesRepEmail || orderTemplate.salesRepEmail || orderTemplate.sales_rep_email || userEmail || '';

      const orderData = {
        customer_name: selectedCustomer.name,
        customer_id: selectedCustomer._id,
        customer_account: selectedCustomer.account_id,
        package_name: orderTemplate.name,
        campaign: orderTemplate.campaign,
        order_type: orderTemplate.order_type || '',
        custom_price: customPrice,
        agency_commission: agencyCommission,
        package_id: orderTemplate.package_id,
        customer_address: selectedCustomer.address_1 || ' \n' || selectedCustomer.address_2 || ' \n' || selectedCustomer.city || ', ' || selectedCustomer.state || ' ' || selectedCustomer.zip_code || ' ', 
        customer_email: selectedCustomer.contact_email || '',
        customer_phone: selectedCustomer.telephone || '',
        salesRepEmail: effectiveSalesRepEmail,
        sales_rep_email: effectiveSalesRepEmail,
        total_cost: orderTemplate.total_cost,
        total_trade: orderTemplate.total_trade,
        total_package: orderTemplate.total_package,
        total_value: orderTemplate.total_value,
        order_date: normalizeDateValue(orderTemplate.order_date) || toLocalDateString(new Date()),
        start_date: normalizeDateValue(orderTemplate.start_date),
        end_date: normalizeDateValue(orderTemplate.end_date),
        status: 'pending',
        total_quantity: orderTemplate.total_quantity,
        orderlines: orderTemplate.items.map(item => ({
          media_type: item.media_type,
          cart_number: item.cart_number,
          start_date: normalizeDateValue(item.start_date),
          end_date: normalizeDateValue(item.end_date),
          start_time: item.start_time,
          end_time: item.end_time,
          unit_cost: item.unit_cost,
          mon: parseInt(item.mon || 0),
          tues: parseInt(item.tues || 0),
          wed: parseInt(item.wed || 0),
          thur: parseInt(item.thur || 0),
          fri: parseInt(item.fri || 0),
          sat: parseInt(item.sat || 0),
          sun: parseInt(item.sun || 0),
          quantity: parseInt(item.quantity || 0),
          total_cost: item.total_cost
        }))
      };

      // Add order ID for updates
      if (isEditMode && currentOrderId) {
        orderData.id = currentOrderId;
      }

      console.log('Submitting order:', orderData);

      // Use different endpoints for create vs update
      const url = isEditMode 
        ? apiUrl('/order/update') 
        : apiUrl('/order/save');
      
      const method = isEditMode ? 'PUT' : 'POST';

      // Submit to API
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(orderData)
      });

      const responseText = await response.text();
      console.log('Raw response:', responseText);

      if (!response.ok) {
        console.error('Error response:', responseText);
        throw new Error(`HTTP error! status: ${response.status} - ${responseText}`);
      }

      let result;
      try {
        result = JSON.parse(responseText);
      } catch (parseError) {
        if (response.ok) {
          result = { message: isEditMode ? 'Order updated successfully' : 'Order created successfully' };
        } else {
          throw new Error('Server returned invalid JSON: ' + responseText);
        }
      }

      console.log(isEditMode ? 'Order updated successfully:' : 'Order created successfully:', result);
      
      // Redirect to orders list
      window.location.href = '/orders';
      
    } catch (error) {
      console.error('Error submitting order:', error);
      alert(`Failed to ${isEditMode ? 'update' : 'create'} order: ${error.message}`);
    }
  };


  const handleCustomerChange = (customer) => {
    console.log('Selected customer:', customer);
    setSelectedCustomer(customer);
  }

  const handleSalesRepChange = (event) => {
    const nextSalesRepEmail = event.target.value;
    setSalesRepEmail(nextSalesRepEmail);
    setOrderTemplate((prev) => (
      prev
        ? {
            ...prev,
            sales_rep_email: nextSalesRepEmail,
            sales_rep: nextSalesRepEmail,
            salesRepEmail: nextSalesRepEmail,
            account_rep: nextSalesRepEmail,
          }
        : prev
    ));
  }

  const handleCancel = () => {
    window.location.href = '/orders';
  }

  const handleCloneOrder = async () => {
    const sourceId = currentOrderId || orderTemplate?.id;
    if (!sourceId) {
      alert('Unable to clone order: order ID not found');
      return;
    }

    try {
      const response = await fetch(apiUrl(`/order/clone/${sourceId}`), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Clone failed: ${response.status} - ${errorText}`);
      }

      let result = await response.json();

      // Unwrap envelope if present
      if (result?.data) {
        result = result.data;
      }

      // Store clone data for the new order entry form to consume
      sessionStorage.setItem('pendingCloneOrder', JSON.stringify(result));

      // Navigate to order entry as a new (unsaved) order
      window.location.href = '/orderentry/clone';
    } catch (error) {
      console.error('Error cloning order:', error);
      alert(`Failed to clone order: ${error.message}`);
    }
  }

  const handleCreateInvoice = () => {
    const mapOrderLineToEntryLine = (item) => {
      const toLocalDate = (value) => {
        if (!value) return null;
        if (value instanceof Date) return new Date(value.getFullYear(), value.getMonth(), value.getDate());
        if (typeof value === 'string') {
          const datePart = value.includes('T') ? value.split('T')[0] : value;
          const [year, month, day] = datePart.split('-').map((part) => parseInt(part, 10));
          if (!year || !month || !day) return null;
          return new Date(year, month - 1, day);
        }
        const parsed = new Date(value);
        if (Number.isNaN(parsed.getTime())) return null;
        return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
      };

      const startDate = toLocalDate(item.start_date);
      const endDate = toLocalDate(item.end_date);
      const dailyCountsByDay = [
        Number(item.sun || 0),
        Number(item.mon || 0),
        Number(item.tues || 0),
        Number(item.wed || 0),
        Number(item.thur || 0),
        Number(item.fri || 0),
        Number(item.sat || 0),
      ];

      let impressions = 0;
      if (startDate && endDate && endDate >= startDate) {
        const current = new Date(startDate);
        while (current <= endDate) {
          impressions += dailyCountsByDay[current.getDay()] || 0;
          current.setDate(current.getDate() + 1);
        }
      }

      return {
        cart_number: item.cart_number || '',
        title: item.spot?.title || item.spot?.name || '',
        client: orderTemplate?.customer_name || '',
        media_type: item.media_type || 'Spot',
        start_date: item.start_date
          ? (typeof item.start_date === 'string'
              ? item.start_date.slice(0, 16)
              : new Date(item.start_date).toISOString().slice(0, 16))
          : '',
        end_date: item.end_date
          ? (typeof item.end_date === 'string'
              ? item.end_date.slice(0, 16)
              : new Date(item.end_date).toISOString().slice(0, 16))
          : '',
        start_time: item.start_time || '',
        end_time: item.end_time || '',
        impressions: impressions,
        day_part: item.start_time && item.end_time ? `${item.start_time}-${item.end_time}` : (item.start_time || ''),
        rate: item.unit_cost || 0,
      };
    };

    const draftInvoice = {
      customer_id: orderTemplate?.customer_id || '',
      sales_rep_email: getOrderSalesRepEmail() || userEmail || '',
      name: orderTemplate?.name || '',
      order_campaign: orderTemplate?.campaign || '',
      due_date: normalizeDateValue(orderTemplate?.end_date) || normalizeDateValue(orderTemplate?.order_date) || toLocalDateString(new Date()),
      status: 'open',
      amount_due: parseFloat(orderTemplate?.total_cost || 0),
      total_value: parseFloat(orderTemplate?.total_value || 0),
      total_impressions: parseInt(orderTemplate?.total_quantity || 0, 10),
      entry_lines: Array.isArray(orderTemplate?.items)
        ? orderTemplate.items.map(mapOrderLineToEntryLine)
        : [],
      as_run_lines: [],
      order_id: orderTemplate?.id || orderTemplate?._id || '',
    };

    sessionStorage.setItem('pendingInvoiceDraft', JSON.stringify(draftInvoice));
    window.location.href = '/invoiceadd';
  };

  const handleDownloadConfirmation = async () => {
    const orderIdForConfirmation = (orderTemplate?.id || orderTemplate?._id || currentOrderId || '').toString();

    if (!orderIdForConfirmation) {
      alert('Order ID not found. Unable to generate confirmation.');
      return;
    }

    try {
      setIsConfirmationDownloading(true);

      const response = await fetch(apiUrl(`/order/confirm/${orderIdForConfirmation}`), {
        method: 'GET',
        headers: {
          Accept: 'application/pdf',
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to download confirmation: ${response.status} ${response.statusText}`);
      }

      const pdfBlob = await response.blob();
      const pdfUrl = window.URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = `order-confirmation-${orderIdForConfirmation}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(pdfUrl);
    } catch (error) {
      console.error('Error downloading order confirmation PDF:', error);
      alert(`Failed to download confirmation PDF: ${error.message}`);
    } finally {
      setIsConfirmationDownloading(false);
    }
  };

  // Helper function to format date for input type="date"
const formatDateForInput = (dateValue) => {
  console.log('Formatting date:', dateValue);
  if (!dateValue) return '';
  
  // If it's already in YYYY-MM-DD format, return as is
  if (typeof dateValue === 'string' && dateValue.match(/^\d{4}-\d{2}-\d{2}$/)) {
    return dateValue;
  }
  
  // If it's a full datetime string, extract just the date part
  if (typeof dateValue === 'string' && dateValue.includes('T')) {
    return dateValue.split('T')[0];
  }
  
  // If it's a Date object, format it
  if (dateValue instanceof Date) {
    return toLocalDateString(dateValue);
  }
  
  // Try to parse and format
  try {
    const date = new Date(dateValue);
    if (!isNaN(date.getTime())) {
      return toLocalDateString(date);
    }
  } catch (e) {
    console.error('Invalid date:', dateValue);
  }
  
  return '';
};

const formatTimeForInput = (timeValue) => {
  console.log('Formatting time:', timeValue);
  if (!timeValue) return '';
  
  // If it's already in HH:MM format, return as is
  if (typeof timeValue === 'string' && timeValue.match(/^\d{2}:\d{2}$/)) {
    return timeValue;
  }
  
  // If it's an ISO datetime string (0000-01-01T06:00:00Z), extract time
  if (typeof timeValue === 'string' && timeValue.includes('T') && timeValue.includes(':')) {
    try {
      const date = new Date(timeValue);
      if (!isNaN(date.getTime())) {
        // Extract hours and minutes in 24-hour format
        const hours = date.getUTCHours().toString().padStart(2, '0');
        const minutes = date.getUTCMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
      }
    } catch (e) {
      console.error('Error parsing ISO datetime:', e);
    }
  }
  
  // If it's a regular time string with colons, extract HH:MM
  if (typeof timeValue === 'string' && timeValue.includes(':')) {
    const parts = timeValue.split(':');
    const hours = parts[0] ? parts[0].padStart(2, '0') : '00';
    const minutes = parts[1] ? parts[1].padStart(2, '0') : '00';
    return `${hours}:${minutes}`;
  }
  
  return '';
};

  // Debug: log order_type at render time
  console.log('Rendering form - orderTemplate.order_type:', orderTemplate?.order_type, 'full template:', orderTemplate);

  return (
    <div className="lg:pl-72 sm:ml-0 px-0 sm:px-0">
    <Titlebar title={readOnly ? "Order View" : "Order Entry"}/>

        <div className="m-3 px-4 sm:px-6 lg:px-8">
          <div className="sm:flex sm:items-center sm:justify-between">
                <div className="mt-2 sm:flex-auto">
                    <h1 className="text-base font-semibold leading-6 text-gray-900">Package: {orderTemplate.name}</h1>
                    <div className="pt-6 sm:ml-4 sm:mt-0 sm:flex sm:items-start sm:gap-6">
                      <div className="w-64 sm:flex-none">
                        <CustomerComboBox 
                            key={`customer-${customerComboBoxKey}-${selectedCustomer ? selectedCustomer._id : 'no-customer'}`}
                            add={true} 
                            people={customers} 
                            value={selectedCustomer}
                            onChange={handleCustomerChange}
                            disabled={readOnly}
                        />
                      </div>
                      <div className="w-64 sm:flex-none">
                        <label htmlFor="sales_rep_email" className="block text-sm font-medium py-1.5 leading-6 text-gray-900">Sales Rep</label>
                        <select
                          id="sales_rep_email"
                          value={salesRepEmail}
                          onChange={handleSalesRepChange}
                          disabled={readOnly || !isAdmin}
                          className="w-full rounded-md border-0 bg-white py-1.5 pl-2 pr-8 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        >
                          <option value="">Select sales rep</option>
                          {Array.from(new Set([...(salesRepOptions || []), ...(salesRepEmail ? [salesRepEmail] : []), ...(userEmail ? [userEmail] : [])])).map((email) => (
                            <option key={email} value={email}>{email}</option>
                          ))}
                        </select>
                      </div>
                      {readOnly && (
                        <div className="sm:flex-none">
                          <label htmlFor="clone_order" className="block text-sm font-medium py-1.5 leading-6 text-white">.</label>
                          <button
                            type="button"
                            onClick={handleCloneOrder}
                            className="w-28 rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                          >
                            Clone Order
                          </button>
                        </div>
                      )}
                      {readOnly && (
                        <div className="sm:flex-none">
                          <label htmlFor="confirmation_action" className="block text-sm font-medium py-1.5 leading-6 text-white">.</label>
                          <button
                            id="confirmation_action"
                            type="button"
                            onClick={handleDownloadConfirmation}
                            disabled={isConfirmationDownloading}
                            className="w-32 rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 disabled:opacity-60 disabled:cursor-not-allowed focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                          >
                            {isConfirmationDownloading ? 'Downloading...' : 'Confirmation'}
                          </button>
                        </div>
                      )}
                      {canManageInvoice && (
                        <div className="sm:flex-none">
                          <label htmlFor="invoice_action" className="block text-sm font-medium py-1.5 leading-6 text-white">.</label>
                          {isInvoiceLookupLoading ? (
                            <button
                              id="invoice_action"
                              type="button"
                              disabled
                              className="w-32 rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm disabled:opacity-60 disabled:cursor-not-allowed"
                            >
                              Checking...
                            </button>
                          ) : linkedInvoiceId ? (
                            <Link
                              id="invoice_action"
                              to={`/invoiceview/${linkedInvoiceId}`}
                              className="block w-32 rounded-md bg-emerald-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-emerald-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-600"
                            >
                              View Invoice
                            </Link>
                          ) : (
                            <button
                              id="invoice_action"
                              type="button"
                              onClick={handleCreateInvoice}
                              className="w-32 rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            >
                              Create Invoice
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                </div>
            </div>
            <div className="mt-2 pl-4 sm:flex sm:items-end sm:gap-6">
                    <div className="w-64 sm:flex-none">
                      <label for="campaign" className="block text-sm font-medium py-1.5 leading-6 text-gray-900">Campaign</label>
                      <input className="w-64 rounded-md border-0 bg-white py-1.5 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                          type="text"
                          value={orderTemplate.campaign}
                          placeholder="Campaign Name"
                        readOnly={readOnly}
                          onChange={(e) => {
                              let clonedOrderTemplate = {...orderTemplate};
                              clonedOrderTemplate.campaign = e.target.value;
                              setOrderTemplate(clonedOrderTemplate);
                          }}
                      />
                    </div>
                    {isAdmin && (
                      <div className="w-64 sm:flex-none">
                        <label htmlFor="order_type" className="block text-sm font-medium py-1.5 leading-6 text-gray-900">Order Type</label>
                        <select
                          id="order_type"
                          value={orderTemplate.order_type || ''}
                          onChange={(e) => {
                            console.log('order_type changed to:', e.target.value);
                            let clonedOrderTemplate = {...orderTemplate};
                            clonedOrderTemplate.order_type = e.target.value;
                            setOrderTemplate(clonedOrderTemplate);
                            // Recalculate totals after state update
                            setTimeout(() => { totals(clonedOrderTemplate); }, 0);
                          }}
                          disabled={readOnly || !isAdmin}
                          className="w-full rounded-md border-0 bg-white py-1.5 pl-2 pr-8 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        >
                          <option value="">Select order type</option>
                          <option value="Cash">Cash</option>
                          <option value="Agency">Agency</option>
                          <option value="Trade">Trade</option>
                        </select>
                      </div>
                    )}
            </div>
            <div className="mt-2 pl-4 flex items-end space-x-6">
                    <div>
                      <label htmlFor="customprice" className="block text-sm font-medium py-1.5 leading-6 text-gray-900">Custom Price</label>
                      <input id="customprice" type="number" value={customPrice} readOnly={readOnly} onChange={(e) => setCustomPrice(e.target.value)} className="w-64 rounded-md border-0 bg-white py-1.5 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                    </div>
                    { (orderTemplate?.order_type || '').toString().toLowerCase() === 'agency' && (
                      <div>
                        <label htmlFor="agency_commission" className="block text-sm font-medium py-1.5 leading-6 text-gray-900">Agency Commission %</label>
                        <input
                          id="agency_commission"
                          type="number"
                          step="0.1"
                          min="0"
                          max="100"
                          value={agencyCommission}
                          onChange={(e) => {
                            const parsed = parseFloat(e.target.value);
                            const val = Number.isNaN(parsed) ? 0 : parsed;
                            setAgencyCommission(val);
                            setOrderTemplate(prev => ({ ...(prev || {}), agency_commission: val, order_type: (val > 0 ? 'Agency' : (prev?.order_type || '')) }));
                            setTimeout(() => { totals(); }, 0);
                          }}
                          readOnly={readOnly}
                          className="w-36 rounded-md border-0 bg-white py-1.5 pr-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                      </div>
                    )}
            </div>
                <div className={`-mx-4 mt-8 flow-root sm:mx-0 ${readOnly ? 'pointer-events-none' : ''}`}>
            <div>
                <div className="text-right sticky right-0">
                  {!readOnly && (
                    <button
                      type="button"
                      onClick={addOrderLine}
                      className="w-28 rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Add Line</button>
                  )}
                </div>

                <div className="border-b border-gray-300 text-gray-900">
                <div>
                    <dd className="w-1.5 px-3 py-3 text-sm font-semibold text-gray-900 sm:table-cell">
                       {/* Button with trash can icon   */}
                       {!readOnly && (
                       <button
                          type="button"
                          onClick={deleteOrderLines}
                          disabled={!checkedItems.length > 0}
                          className="rounded-full bg-indigo-600 p-1 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        >
                          <TrashIcon aria-hidden="true" className="h-5 w-5" />
                        </button>
                      )}
                    </dd>    
                    <dd className="w-2/12 py-3 text-left text-sm font-semibold text-gray-900 sm:table-cell">
                    Media
                    </dd>
                    <dd className="w-1/12 py-3 text-center hidden text-sm font-semibold text-gray-900 sm:table-cell">
                    Start
                    </dd>
                    <dd className="w-1/12 py-3 text-center hidden text-sm font-semibold text-gray-900 sm:table-cell"
                    >
                    End
                    </dd>
                    <dd className="w-7/12 py-3 text-center hidden text-sm font-semibold text-gray-900 sm:table-cell"
                    >
                    Days
                    </dd>
                    <dd className="w-1/12 py-3 text-right text-sm font-semibold text-gray-900 sm:table-cell sm:pr-0">
                    Price
                    </dd>
                </div>
                </div>
                <div>
        {orderTemplate.items &&
          orderTemplate.items.map((item, index) => (
            <div key={item.id} className="border-b border-gray-200">
              <dl className="w-1.5 whitespace-nowrap px-3 py-5 text-sm text-gray-500 sm:table-cell">
                <dt className="font-medium text-gray-900">
                <input 
                  type="checkbox" 
                  checked={orderTemplate.items[index].checked}
                  onChange={setCheckedItem(index)} 
                  className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                />
                </dt>
                <dd></dd>
              </dl>
              
              <dl className="w-2/12 hidden py-3 text-sm text-gray-500 sm:table-cell">
                <dt className="font-medium text-gray-900">
                <MediaTypeDropdown
                    name={`media_type`}
                    id={`media_type-${index}`}
                    value={item.media_type}
                    onChange={handleItemChange(index, 'media_type')}
                    className="grow-0 block w-full min-w-[4.5rem] rounded-md border-0 px-2 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
                </dt>              
                <dd className="mt-1.5 pr-2 truncate text-gray-500">
                  <SpotComboBox 
                    className="w-32"
                    spots={spots} // Pass the fetched spots
                    value={item.spot} 
                    onChange={handleItemChange(index, 'spot')} 
                  />
                </dd>
              </dl>
              
              <dl className="w-1/12 hidden py-3 text-sm sm:table-cell sm:pr-0">
                <dt className="font-medium text-gray-900">
                  <input
                    className="grow-0 block w-full min-w-[4.5rem] rounded-md border-0 px-2 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    aria-label="Start Date"
                    type="date"
                    value={formatDateForInput(item.start_date)}
                    onChange={handleItemChange(index, 'start_date')}
                  />
                </dt>
                <dd className="mt-1.5 truncate text-gray-500">
                  <input 
                    className="grow-0 block w-full rounded-md border-0 px-2 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" 
                    type="time" 
                    value={item.start_time}
                    onChange={handleItemChange(index, 'start_time')}
                  />
                </dd>
              </dl>
              
              <dl className="w-1/12 hidden py-3 px-3 text-sm sm:table-cell sm:pr-0">
                <dt className="font-medium text-gray-900">
                  <input 
                    className="grow-0 block w-full rounded-md border-0 px-2 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" 
                    aria-label="End Date" 
                    type="date" 
                    value={formatDateForInput(item.end_date)}
                    onChange={handleItemChange(index, 'end_date')}
                  />
                </dt>
                <dd className="mt-1.5 truncate text-gray-500">
                  <input 
                    className="grow-0 block w-full rounded-md border-0 px-2 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" 
                    type="time" 
                    value={item.end_time}
                    onChange={handleItemChange(index, 'end_time')}
                  />    
                </dd>
              </dl>
              
              {/* Days of the week inputs */}
              <dl className="w-1/12 py-3 pl-2 text-sm sm:table-cell sm:pr-0">
                <dt className="flex items-center h-8 font-medium text-xs text-gray-500">Mon</dt>
                <dd className="mt-1.5 text-gray-500">
                  <input
                    type="number"
                    name="mon"
                    id={`mon-${index}`}
                    placeholder="0"
                    value={item.mon}
                    onChange={handleItemChange(index, 'mon')}
                    className="grow-0 block w-full min-w-[4.5rem] rounded-md border-0 px-2 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                </dd>
              </dl>
              
              <dl className="w-1/12 py-3 text-sm sm:table-cell sm:pr-0">
                <dt className="flex items-center h-8 font-medium text-xs text-gray-500">Tue</dt>
                <dd className="mt-1.5 text-gray-500">
                  <input
                    type="number"
                    name="tues"
                    id={`tues-${index}`}
                    placeholder="0"
                    value={item.tues}
                    onChange={handleItemChange(index, 'tues')}
                    className="grow-0 block w-full min-w-[4.5rem] rounded-md border-0 px-2 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                </dd>
              </dl>
              
              <dl className="w-1/12 py-3 text-sm sm:table-cell sm:pr-0">
                <dt className="flex items-center h-8 font-medium text-xs text-gray-500">Wed</dt>
                <dd className="mt-1.5 text-gray-500">
                  <input
                    type="number"
                    name="wed"
                    id={`wed-${index}`}
                    placeholder="0"
                    value={item.wed}
                    onChange={handleItemChange(index, 'wed')}
                    className="grow-0 block w-full min-w-[4.5rem] rounded-md border-0 px-2 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                </dd>
              </dl>
              
              <dl className="w-1/12 py-3 text-sm sm:table-cell sm:pr-0">
                <dt className="flex items-center h-8 font-medium text-xs text-gray-500">Thu</dt>
                <dd className="mt-1.5 text-gray-500">
                  <input
                    type="number"
                    name="thur"
                    id={`thur-${index}`}
                    placeholder="0"
                    value={item.thur}
                    onChange={handleItemChange(index, 'thur')}
                    className="grow-0 block w-full min-w-[4.5rem] rounded-md border-0 px-2 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                </dd>
              </dl>
              
              <dl className="w-1/12 py-3 text-sm sm:table-cell sm:pr-0">
                <dt className="flex items-center h-8 font-medium text-xs text-gray-500">Fri</dt>
                <dd className="mt-1.5 text-gray-500">
                  <input
                    type="number"
                    name="fri"
                    id={`fri-${index}`}
                    placeholder="0"
                    value={item.fri}
                    onChange={handleItemChange(index, 'fri')}
                    className="grow-0 block w-full min-w-[4.5rem] rounded-md border-0 px-2 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                </dd>
              </dl>
              
              <dl className="w-1/12 py-3 text-sm sm:table-cell sm:pr-0">
                <dt className="flex items-center h-8 font-medium text-xs text-gray-500">Sat</dt>
                <dd className="mt-1.5 text-gray-500">
                  <input
                    type="number"
                    name="sat"
                    id={`sat-${index}`}
                    placeholder="0"
                    value={item.sat}
                    onChange={handleItemChange(index, 'sat')}
                    className="grow-0 block w-full min-w-[4.5rem] rounded-md border-0 px-2 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                </dd>
              </dl>
              
              <dl className="w-1/12 py-3 text-sm sm:table-cell sm:pr-0">
                <dt className="flex items-center h-8 font-medium text-xs text-gray-500">Sun</dt>
                <dd className="mt-1.5 text-gray-500">
                  <input
                    type="number"
                    name="sun"
                    id={`sun-${index}`}
                    placeholder="0"
                    value={item.sun}
                    onChange={handleItemChange(index, 'sun')}
                    className="grow-0 block w-full min-w-[4.5rem] rounded-md border-0 px-2 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                </dd>
              </dl>
              
              <dl className="w-2/12 py-3 text-right text-sm sm:table-cell sm:pr-0">
                <dt className="flex items-center h-8 font-medium text-xs text-gray-500">Unit</dt>
                <dd className="mt-1.5">
                  <input
                    type="text"
                    inputMode="decimal"
                    value={currencyFormatter.format(Number(item.unit_cost || 0))}
                    onChange={handleUnitCostChange(index)}
                    readOnly={readOnly}
                    className="grow-0 inline-block w-28 rounded-md border-0 px-2 py-1 text-gray-900 text-right shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                </dd>
                <dd className="mt-1.5 pt-3.5 truncate text-gray-500">{currencyFormatter.format(Number(item.total_cost || 0))}</dd>
              </dl>
            </div>
          ))}
        
                </div>
                <div className="text-right sticky right-0">
                    <div className="border-t border-gray-400">
                        <div className="w-8/12 table-cell text-white">_</div>
                        <div className="w-11/12 pt-2 text-right text-sm font-normal text-gray-500 table-cell sticky right-2">
                        Trade
                        </div>
                        <div className="w-12/12 py-2 pl-14 mr-0 text-right text-sm text-gray-500 table-cell sticky right-0">${orderTemplate.total_trade}.00</div>
                    </div>
                    <div className="border-t border-gray-400">
                        <div className="w-8/12 table-cell text-white">_</div>
                        <div className="w-11/12 pt-4 text-right text-sm font-semibold text-gray-900 table-cell sticky right-2">
                        Cash Total
                        </div>
                        <div className="w-12/12 pt-3 pl-14 mr-0 text-right text-sm text-black-900 table-cell sticky right-0">${orderTemplate.total_cost}.00</div>
                    </div>
                    <div>
                        <div className="w-8/12 table-cell text-white">_</div>
                        <div className="w-11/12 pt-2 text-right text-sm font-normal text-gray-500 table-cell sticky right-2">
                        Subtotal
                        </div>
                        <div className="w-12/12 py-2 pl-14 mr-0 text-right text-sm text-gray-500 table-cell sticky right-0">${orderTemplate.total_cost}.00</div>
                    </div>
                    <div>
                        <div className="w-8/12 table-cell text-white">_</div>
                        <div className="w-11/12 text-right text-sm font-semibold text-gray-900 table-cell sticky right-2">
                        Total Value
                        </div>
                        <div className="w-12/12 pt-3 pl-14 mr-0 text-right text-sm text-black-900 table-cell sticky right-0">${orderTemplate.total_value}.00</div>
                    </div>
                </div>
                <div className="text-right sticky right-0 mt-5">
                    {!readOnly && (
                      <div className="inline-flex items-center gap-2">
                        <button
                          type="button"
                          onClick={handleCancel}
                          className="rounded-md bg-white px-3 py-2 text-center text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          onClick={submitOrder}
                          className="rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        >
                          Submit Order
                        </button>
                      </div>
                    )}
                </div>
            </div>
            </div>
        </div> 
    </div>
  );
}

export default OrderEntryForm;